/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

(function () {
  // Add custom code below this line

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
  let promoBlock = document.querySelectorAll(".promo-blocks");
  if (promoBlock.length) {
    promoBlock.forEach(function (e) {
      var position = e.getAttribute("data-position");
      var isIpadOrMobile = screen.width < 1025 ? true : false;
      if (isIpadOrMobile) {
        position = e.getAttribute("data-position-mob");
      }
      var promo_html = e.innerHTML;
      position = parseInt(position);
      if (position > 0 && promo_html) {
        const slides = document.querySelector(
          `.template-collection .product-item.product-item-${position}`
        );
        slides.insertAdjacentHTML("beforebegin", promo_html);
      }
    });
  }
})();
